import probeTypes from "../../assets/conf/probe_types.json";
import probeLabels from "../../assets/conf/probe_labels.json";
import { keyBy } from "lodash";
import { formatToPrecision } from "@/shared/utils/numbers";
import { PoolDetails } from "@/models/pool-details.model";
import { Pool } from "@/models/pool.model";
import i18n from "@/core/i18n";
import { useApi } from "@/services/useApi.ts";

const { t } = i18n.global;

export type ProbeTypeDef = {
  precision: number;
  unit: string;
  chartMinExtent?: number;
  chartMinOrigin?: number;
  sliderRange: [number, number];
  defaultMin: number;
  defaultMax: number;
  defaultConsigne?: number;
  out?: string;
  gap: number;
  minRoleToChange: number;
  name: string;
};

export const probeTypesMap = keyBy(probeTypes, (probeType) => probeType.type);
export const probeLabelsMap = keyBy(
  probeLabels,
  (probeLabels) => probeLabels.index
);

export const getProbeType = (type: string | number) =>
  probeTypesMap[type] as unknown as ProbeTypeDef;
export const getProbeLabel = (index: string | number) =>
  probeLabelsMap[index].label;

export const formatProbeValue = (type: string | number, value: number) => {
  if (type === 12) {
    // Custom format for bidon
    if (value >= 100) {
      return t("Ok");
    } else if (value <= 0) {
      return t("Unknown");
    }
  }
  return formatToPrecision(value, getProbeType(type).precision!);
};

export const isProbeHiddenForHivernage = (type: string | number) => {
  const typeName = getProbeType(type).name;

  return [
    "TYPE_CAPTEUR_REDOX",
    "TYPE_CAPTEUR_PH",
    "TYPE_CAPTEUR_CHLORE",
  ].includes(typeName);
};

export const shouldHideProbeValueUnit = (type: number, value: number) => {
  // Custom format for bidon
  return type === 12 && (value >= 100 || value <= 0);
};

export const deserializeProbe = (
  probe: PoolDetails["probes"][number]
): PoolDetails["probes"][number] => {
  return probe;
};

export const useSaveProbe = () => {
  const api = useApi();
  return (probe: Pool["probes"][number], poolID: number): Promise<unknown> => {
    return api
      .setSeuils({
        poolID,
        probe: probe.index,
        seuilMin: probe.seuilMin,
        seuilMax: probe.seuilMax,
      })
      .then(api.waitCommand);
  };
};
